import { Component, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { DeviceHelper } from "../../helpers/device.helper";
import { NavControllerExtended } from "../../helpers/navControllerExtended";
import { HammerJsPage } from "../../pages/hammerJs.page.base";

@Component({
    templateUrl: "view.modal.html",
    styleUrls: ["view.modal.scss"],
})
export class ViewModal extends HammerJsPage {
    @Input() imageData: string = "";

    constructor(deviceHelper: DeviceHelper,
                private navCtrl: NavControllerExtended,
                private modalController: ModalController) {
        super(deviceHelper);

        if (this.navCtrl.params.hasParam("imageData")) {
            this.imageData = this.navCtrl.params.getParam("imageData") as string;
        }
    }

    ionViewDidEnter() {
        super.ionViewDidEnter();

        if (this.imageData.length > 0) {
            let image = new Image();
            image.src = this.imageData;
            image.onload = () => {
            };
        }
    }

    public dismiss() {
        this.modalController.dismiss();
    }
}
